import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import Form from 'react-bootstrap/Form';
import { utils, writeFileXLSX } from 'xlsx';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik } from 'formik';
import * as yup from 'yup';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ModalAllder } from 'layouts/ModalAllder';
import { DataGrid } from '@mui/x-data-grid';

export default function ConfirmDeleteModal({ modal, setModal, editData, onConfirm, itemType = 'รายการ' }) {
  const canDelete = !editData?.customers || editData?.customers === 0;

  return (
    <ModalAllder modal={modal} setModal={setModal} htitle="ยืนยันการลบ" hbtn={false}>
      <div className="py-4">
        {!canDelete ? (
          <div>
            <div className="text-center fs-22 tc-7 mb-2">ขออภัยไม่สามารถลบได้</div>
            <div className="text-center fs-22 tc-7">เนื่องจากมีสมาชิกอยู่ใน{itemType}</div>
            <div className="text-center pt-4 mt-3 btn-group-control">
              <Button
                type="button"
                className="btn-st-3 mx-3"
                style={{ width: '100px' }}
                onClick={() => setModal(prev => ({ ...prev, open: false }))}
              >
                ตกลง
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <div className="text-center fs-22 tc-7 mb-2">คุณต้องการลบ</div>
            <div className="text-center fs-22 tc-7">{itemType}นี้ใช่หรือไม่</div>
            <div className="text-center pt-4 mt-3 btn-group-control">
              <Button type="button" className="btn-st-3 mx-3" style={{ width: '100px' }} onClick={onConfirm}>
                ใช่
              </Button>
              <Button
                type="button"
                className="btn-st-6 mx-3"
                style={{ width: '100px' }}
                onClick={() => setModal(prev => ({ ...prev, open: false }))}
              >
                ไม่ใช่
              </Button>
            </div>
          </div>
        )}
      </div>
    </ModalAllder>
  );
}
